const BASE_URL = () => (window.project_id ? `/projects/${window.project_id}` : '');

export default {
    LTD_CHARTS_DATA: `${BASE_URL()}/charts/ltd/data`,
    CFD_CHARTS_DATA: `${BASE_URL()}/charts/cfd/data`,
    CHARTS_DATA: (chartType) =>  `${BASE_URL()}/charts/${chartType}/data`,
    CHARTS_QUERY: `${BASE_URL()}/charts/query`,
    CHARTS_QUERY_BY_ID: (query_id) => `${BASE_URL()}/charts/query/${query_id}`,
};
